export const styles = {
  chip: {
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    padding: '0 8px',
    borderRadius: '20px',
    color: (theme) => `${theme.palette.blues.babyBlue900}!important`,
    backgroundColor: (theme) => theme.palette.blues.babyBlue200,
  },
  text: {
    maxWidth: '100px',
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis',
    fontSize: '12px',
    color: (theme) => `${theme.palette.blues.babyBlue900}!important`,
  },
};
